import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postExtractForecastFromSAPSlice = createApi(`PostExtractForecastFromSAPSlice`,"POST");

const PostExtractForecastFromSAPSlice = createSlice({
  name: 'PostExtractForecastFromSAPSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postExtractForecastFromSAPSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postExtractForecastFromSAPSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postExtractForecastFromSAPSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostExtractForecastFromSAPSlice.reducer;